import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgClass, NgIf, NgOptimizedImage } from '@angular/common';
import { LoginService } from '../../../../service/login.service';
import { ILoggedInUserViewModel } from '../../../../model/common.model';

@Component({
  selector: 'app-sidebar-header',
  standalone: true,
  templateUrl: './sidebar-header.component.html',
  styleUrls: ['./sidebar-header.component.scss'],
  imports: [MatButtonModule, MatIconModule, NgOptimizedImage, NgClass, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarHeaderComponent {
  @Input() currentUser: ILoggedInUserViewModel | null = null;

  @Input() isMenuOpen?: boolean;

  @Output() isMenuOpenChange: EventEmitter<boolean> = new EventEmitter();

  constructor(private readonly loginService: LoginService) {}

  /**
   * Navigate to the dashboard page based on current user role
   */
  redirectToRoleRespectiveDashboard(): void {
    this.loginService.redirectToRespectiveDashboard(this.currentUser?.role);
  }

  /**
   * toggle 'isMenuOpen' property and emit to parent
   */
  toggleIsMenuOpen(): void {
    this.isMenuOpen = !this.isMenuOpen;

    this.isMenuOpenChange.emit(this.isMenuOpen);
  }
}
